"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EmergencyContacts = _interopRequireDefault(require("./EmergencyContacts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _EmergencyContacts.default;
exports.default = _default;